import { MapUtils } from '../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { ICloneable } from '../../contracts/cloneable.js';
import { IDataComparable } from '../../contracts/data-comparable.js';
import { cloneListOfCloneable, isSameData, isSameList } from '../dto/data-model-utils.js';

export class ObjectListRenderOrder extends DataModel {
  static readonly TYPE_ID: string = 'afef4d195f2545fba1679111ff6565c7';

  private constructor(
    private readonly renderOrder: ObjectRenderOrder[],
  ) {
    super();
  }

  get $typeId(): string {
    return ObjectListRenderOrder.TYPE_ID;
  }

  get isEmpty(): boolean {
    return this.renderOrder.length === 0;
  }

  get isNotEmpty(): boolean {
    return this.renderOrder.length > 0;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ObjectListRenderOrder {
    return new ObjectListRenderOrder(
        MapUtils.getList<ObjectRenderOrder>(map, 'renderOrder', (e) => {
          return ObjectRenderOrder.fromMap(context, e as SerializedData);
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'renderOrder': this.renderOrder.map((e) => e.toMap(context)),
    };
  }

  clone(): this {
    return new ObjectListRenderOrder(
        cloneListOfCloneable(this.renderOrder),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.renderOrder, this.renderOrder, (a, b) => isSameData(a, b));
  }

  indexOf(objectId: string): number {
    for(let i: number = 0; i < this.renderOrder.length; ++i) {
      const item = this.renderOrder[i];
      if(item.objectId === objectId) {
        return item.index;
      }
    }

    return -1;
  }
}

export class ObjectListRenderOrderBuilder extends DataModelBuilder<ObjectListRenderOrder> {
  build(context: SerializationContext, map: SerializedData): ObjectListRenderOrder {
    return ObjectListRenderOrder.fromMap(context, map);
  }
}

class ObjectRenderOrder implements ICloneable, IDataComparable {
  private constructor(
    public readonly objectId: string,
    public readonly index: number,
  ) {}

  static fromMap(context: SerializationContext, map: SerializedData): ObjectRenderOrder {
    return new ObjectRenderOrder(
        MapUtils.getString(map, 'objectId'),
        MapUtils.getInteger(map, 'index'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'objectId': this.objectId,
      'index': this.index,
    };
  }

  clone(): this {
    return new ObjectRenderOrder(
        this.objectId,
        this.index,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.objectId === this.objectId && other.index === this.index;
  }
}
